module.exports = __webpack_public_path__ + "static/media/feature1.27b544c2.png";